import React from 'react';

function JobSupportSection() {
  return (
    <div className="bg-white py-12">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-5xl md:text-6xl font-bold text-gray-800 mb-4 transform transition-all duration-300 hover:scale-105 hover:text-gray-900">
          We are here to help everyone in need of JOB!
        </h2>
        <h3 className="text-2xl md:text-3xl text-gray-600 mb-8 transform transition-all duration-300 hover:scale-105 hover:text-gray-700">
          Providing an employment opportunity is the greatest charity ever done.
        </h3>
        <p className="text-lg md:text-xl text-gray-600 mb-6 text-justify max-w-4xl mx-auto transition-colors duration-300 hover:text-gray-800">
          Ceyone Foundations is set up by professionals from various fields to support Younger India to enhance personal skills, career analysis & assessment, get better job as per their education qualification & skills, and transform their lives through better career opportunities, involve in various methods in nation to bring changes to society to build better India & countrymen live towards respectful life.
        </p>
        <p className="text-lg md:text-xl text-gray-600 text-justify max-w-4xl mx-auto transition-colors duration-300 hover:text-gray-800">
          The organization is founded to motivate and build the Creative skillsets, to implement Human Resource Development, management and standards, Career development & guidance, create entrepreneurs, modular employability, placements & recruitments, vocational training, assist in scholarships & educational loans to empower the youth towards service excellence in their personnel life as well as in their career with the support of private and public sectors.
        </p>
      </div>
    </div>
  );
}

export default JobSupportSection;